import React, { createContext, useState, useContext, useCallback } from 'react'
import { attachmentService, Attachment } from '../services/attach.service'

interface AttachmentsContextType {
  attachments: Attachment[]
  fetchAttachments: (number: string) => Promise<void>
  isLoading: boolean
  error: string | null
}

const AttachmentsContext = createContext<AttachmentsContextType | undefined>(undefined)

export const AttachmentsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [attachments, setAttachments] = useState<Attachment[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchAttachments = useCallback(async (number: string) => {
    setIsLoading(true)
    setError(null)
    try {
      const fetchedAttachments = await attachmentService.getAttachments(number)
      console.log('Fetched attachments:', fetchedAttachments)
      setAttachments(fetchedAttachments ?? [])
    } catch (err) {
      setError('Failed to fetch attachments')
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }, [])

  return (
    <AttachmentsContext.Provider value={{ attachments, fetchAttachments, isLoading, error }}>
      {children}
    </AttachmentsContext.Provider>
  )
}

export const useAttachments = (): AttachmentsContextType => {
  const context = useContext(AttachmentsContext)
  if (context === undefined) {
    throw new Error('useAttachments must be used within an AttachmentsProvider')
  }
  return context
}
